module.exports = __webpack_public_path__ + "static/media/patient-avatar-4.d4156b9c.svg";